import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { axiosInstance } from '../../core/auth/RequestInterceptor';


const account_service_endpoint = process.env.REACT_APP_ACCOUNT_SERVICE_ENDPOINT || ''; 
const inbound_service_endpoint = process.env.REACT_APP_INBOUND_SERVICE_ENDPOINT || ''; 
const mobile_inbound_service_endpoint = process.env.REACT_APP_MOBILE_INBOUND_SERVICE_ENDPOINT || '';
const inventory_service_endpoint = process.env.REACT_APP_INVENTORY_SERVICE_ENDPOINT || '';
const outbound_service_endpoint = process.env.REACT_APP_OUTBOUND_SERVICE_ENDPOINT || '';

export const ServiceEndPoint = {
    account_service: account_service_endpoint,
    inbound_service: inbound_service_endpoint,
    mobile_inbound_service: mobile_inbound_service_endpoint,
    inventory_service: inventory_service_endpoint,
    outbound_service: outbound_service_endpoint
};
export const axiosService = {
    get: (url: string, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
       return axiosInstance.get(`${url}`, config);
    },
    post: (url: string, data: any, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
        return axiosInstance.post(`${url}`, data, config);
    },
    put: (url: string, data: any, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
        return axiosInstance.put(`${url}`, data, config);
    },
    delete: (url: string, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
        return axiosInstance.delete(`${url}`, config);
    },
    patch: (url: string, data: any, config?: AxiosRequestConfig): Promise<AxiosResponse> => {
        return axiosInstance.patch(`${url}`, data, config);
    },
};

